import React from "react"

export default class FormFooterLink extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="FormFooterLink">
				<div className="row">
					<div className="col-sm-12">
						<a href={this.props.path}>{this.props.text}</a>
					</div>
				</div>
			</div>
		);	
	}

}